import { debug } from 'util';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpHandler } from '@angular/common/http';
import { AppGlobal } from '../app.global';
import { Menu } from 'src/app/theme/components/menu/menu.model';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(private http: HttpClient, private config: AppGlobal, private handler: HttpHandler) {
    localStorage.setItem('usersession', JSON.stringify(new Date()));
  }

  getRoleAccess(token: string, userId: string, orgID: any, orgMmberid: any) {
    //console.log('hello:');
    const reqheader = new HttpHeaders({ 'x-access-token': token, 'Content-Type': 'application/json' });
    const data = {
      process: this.config.GET_MEMBER_MODULE_ACCESS, userid: userId, orgid: orgID, orgmemberid: orgMmberid,
      plattype: this.config.PLATFORM_TYPE
    };
    return this.http.post(this.config.apiUrl, data, { headers: reqheader });
  }
  getmoduleAccess(token: string, userId: string, orgID: any, appname:string,orgmemberid: any) {
    //console.log('hello:');
    const reqheader = new HttpHeaders({ 'x-access-token': token, 'Content-Type': 'application/json' });
    const data = {
      process: this.config.GET_MODULES_BY_APP, 
      userid: userId,
       orgid: orgID,
       whichapp:appname,
       orgmemberid:orgmemberid,
      plattype: this.config.PLATFORM_TYPE
    };
    return this.http.post(this.config.apiUrl, data, { headers: reqheader });
  }

  updateModuleAccess(token: string, userId: string, userType: any, orgMmberid: any, moduleId:any,
    canRead:any, canAdd:any , canEdit: any,canDelete:any) {
    //console.log('hello:');
    const reqheader = new HttpHeaders({ 'x-access-token': token, 'Content-Type': 'application/json' });
    const data = {
      process: this.config.UPDATE_MODULE_ACCESS,
      userid: userId,
      userType: userType,
      orgmemberid: orgMmberid,
      module_id : moduleId,
      can_read: canRead,
      can_add: canAdd,
      can_edit: canEdit,
      can_delete: canDelete,
      plattype: this.config.PLATFORM_TYPE
    };
    return this.http.post(this.config.apiUrl, data, { headers: reqheader });
  }

  generateMenuItems(items) {
    const menu_items = [];
    for (let i = 0; i < items.length; i++) {
      menu_items[i] = new Menu(
      items[i].module_id,
      items[i].module_title,
      items[i].module_routerLink,
      items[i].module_href,
      items[i].module_icon,
      items[i].module_target,
      items[i].module_hasSubMenu,
      items[i].module_parentId);
        // 
    }
    return menu_items;

    // module_hasSubMenu: "false"
    // module_href: "null"
    // module_icon: "dashboard"
    // module_id: 1
    // module_parentId: 0
    // module_routerLink: "views/dashboard"
    // module_serial: 1
    // module_target: "null"
    // module_title: "Dashboard"

  }
}
